import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import ModalCloseButton from './ModalCloseButton.jsx';
import useStickyState from './UseStickyState.jsx';

/**
 * Banner that announces there will be a downtime
 */
const DowntimeBanner = (props) => {
	const { user } = props;
	const [ closed, setClosed ] = useStickyState(false, 'downtime-banner-' + user.emailAddress);

	/**
	 * Closes the banner
	 */
	const handleClose = ()=> {
		setClosed(!closed);
	};

	return (
		<Row className={'downtime-banner' + (closed ? ' fade-out' : '')}>
			<Container>
				<Row>
					<Col xs={'12'} className={'d-flex align-center'}>
						<div className={'downtime-block'}>
							<i className={'fa-solid fa-hexagon-exclamation main-icon'} aria-hidden="true"></i>
							<p><strong>🌞 Shmoop’s Getting a Glow-Up</strong><br/>
								On <b>Saturday, July 12st and Sunday, July 13nd</b>, Shmoop.com will be offline occasionally while we clean the servers, de-grease the data, and give the Wi-Fi a motivational pep talk.
								 😸 Hang in there, and we’ll be back with fewer bugs and more brains.</p>
						</div>
					</Col>
				</Row>
			</Container>
			<ModalCloseButton label={'Close'} closeFunc={handleClose} />
		</Row>
	);
};

export default DowntimeBanner;

DowntimeBanner.propTypes = {
	user: PropTypes.object
};
